import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';
import Login from './LoginPage';
import Documents from './Documents';
import Keypad from './components/Keypad';
import Header from './components/Header';
import Footer from './components/Footer';

const styles = theme => ({
  flex: {
    flex: 1
  },
  appWrapper: {
    marginTop: '80px',
    marginBottom: '80px',
    width: '100vw',
    height: '100vh',
    overflowY: 'auto'
  }
});

function Main(props) {
  const { classes } = props;
  return (
    <Router>
      <div>
        <Header />
        <div className={classes.appWrapper}>
          <Switch>
            <Route exact={true} path="/" component={Login} />
            <Route path="/Keypad" component={Keypad} />
            <Route path="/documents" component={Documents} />
            <Redirect to="/" />
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

Main.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Main);



// WEBPACK FOOTER //
// ./src/Main.js